export default {
    copyMigrateModal: {
        title: 'Copy {count} bins from {date}',
        source: 'Source: {date} (sum {sum})',
        selectTargets: 'Select target days (overwrite preview shown):',
        lengthMismatch: 'DST length mismatch — bins will be truncated or padded',
        overwriteWarning: '{count} selected day(s) have existing edits that will be overwritten:',
        confirmCopy: 'Confirm copy ({count})',
    },
}
